import component from './component';

component.install = function (Vue) {
  Vue.component(component.name, component);
};

export default component;